export const CardModel = {
  address: null,
  amount: null,
  bankCode: null,
  bookingDate: null,
  creditorId: null,
  currency: null,
  eref: null,
  iban: null,
  id: null,
  informPartnerMethod: 'automatic',
  mref: null,
  name: '[Hinzugefügt]',
  partner: {
    address: null,
    city: null,
    fax: null,
    name: null,
    postcode: null,
    preferredContact: null,
  },
  contracts: [
    {
      active: true,
      amount: '',
      purpose: '',
      transactionDate: null,
    },
  ],
  purpose: null,
  sepaPurposeCode: null,
  sequenceType: 'RCUR',
  suggestedPartners: null,
  ticketId: null,
  transactionCode: null,
  type: null,
};
